import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbsenceEntity } from '@app/models/payroll/absence-entity.model';
import { PRAbsenceSubAccount } from '@app/models/payroll/pr-absence-sub-account-entity';
import { IListService } from '@app/services';

@Injectable()
export class AbsenceService implements IListService {
	endpointBase = '/api/prabsence';

	constructor(private readonly http: HttpClient) {}

	getList(): Observable<any> {
		return this.http.get<any>(`${this.endpointBase}/list`);
	}

	getById(Id: number): Observable<AbsenceEntity> {
		return this.http.get<AbsenceEntity>(`${this.endpointBase}/${Id}`);
	}

	deleteEntity(Id: number): Observable<any> {
		return this.http.delete<any>(`${this.endpointBase}/${Id}`);
	}

	createEntity(entity: AbsenceEntity): Observable<any> {
		return this.http.post<any>(this.endpointBase, entity);
	}

	updateEntity(entity: AbsenceEntity): Observable<any> {
		return this.http.post<any>(this.endpointBase, entity);
	}

	getForEPSetup(): Observable<any> {
		return this.http.get<any>(`${this.endpointBase}/for-ep-setup`);
	}

	updateForEPSetup(selectedIds: number[]): Observable<any> {
		return this.http.put<any>(`${this.endpointBase}/for-ep-setup`, selectedIds);
	}

	updatePosition(row: PRAbsenceSubAccount, positionDifference: number): Observable<any> {
		return this.http.post<any>(`${this.endpointBase}/${row.Id}/update-position`, positionDifference);
	}

	getDeductionTypes(): Observable<any> {
		return this.http.get<any>('/api/utils/prabsencededuction');
	}

	createSubAccount(account: PRAbsenceSubAccount): Observable<any> {
		return this.http.post<any>(`${this.endpointBase}/account`, account);
	}
}
